<div class="fy-cgv">
  <app-cgu></app-cgu>
  <app-general-conditions></app-general-conditions>
</div>
